(() => {
  if (window.pmModalKeyboardInit) return;
  window.pmModalKeyboardInit = true;

  const DESKTOP_BREAKPOINT = 750;

  function isTypingTarget(el) {
    if (!el) return false;
    const tag = el.tagName;
    return (
      tag === 'INPUT' ||
      tag === 'TEXTAREA' ||
      tag === 'SELECT' ||
      el.isContentEditable
    );
  }

  function getOpenProductModal() {
    return [...document.querySelectorAll('product-modal')].find((modal) => {
      const dialog = modal.querySelector('[role="dialog"]');
      if (!dialog) return false;

      const modalStyle = window.getComputedStyle(modal);
      const dialogStyle = window.getComputedStyle(dialog);

      return (
        modalStyle.display !== 'none' &&
        modalStyle.visibility !== 'hidden' &&
        dialogStyle.display !== 'none' &&
        dialogStyle.visibility !== 'hidden' &&
        dialog.offsetWidth > 0 &&
        dialog.offsetHeight > 0
      );
    });
  }

  function getMediaItems(modal) {
    return [...modal.querySelectorAll('[data-media-id]')];
  }

  function activateItem(modal, item) {
    if (!item) return;

    const items = getMediaItems(modal);
    items.forEach((el) => el.classList.remove('active'));
    item.classList.add('active');

    const container =
      modal.querySelector('[role="document"]') ||
      modal.querySelector('.product-media-modal__content');

    if (container) {
      const left = item.offsetLeft - (container.clientWidth - item.clientWidth) / 2;
      container.scrollTo({ left, behavior: 'smooth' });
    } else {
      item.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    }
  }

  document.addEventListener('keydown', (event) => {
    if (window.innerWidth < DESKTOP_BREAKPOINT) return;
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
    if (isTypingTarget(document.activeElement)) return;

    const modal = getOpenProductModal();
    if (!modal) return;

    // Если твои кастомные кнопки уже существуют — просто триггерим их
    const prevBtn = modal.querySelector('.pm-modal-nav--prev');
    const nextBtn = modal.querySelector('.pm-modal-nav--next');

    if (prevBtn && nextBtn) {
      event.preventDefault();
      if (event.key === 'ArrowLeft') prevBtn.click();
      if (event.key === 'ArrowRight') nextBtn.click();
      return;
    }

    // Фолбэк: переключаем active item напрямую
    const items = getMediaItems(modal);
    if (!items.length) return;

    let currentIndex = items.findIndex((el) => el.classList.contains('active'));
    if (currentIndex === -1) currentIndex = 0;

    const nextIndex =
      event.key === 'ArrowRight'
        ? (currentIndex + 1) % items.length
        : (currentIndex - 1 + items.length) % items.length;

    event.preventDefault();
    activateItem(modal, items[nextIndex]);
  });
})();